import React, { useState, useEffect } from "react";
import { makeStyles, Box, Button, Container } from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import { apiEndpoints, apiGetByIdRequest } from "src/utils/api/api";
import { addVoteStatisticField } from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import HowToVoteIcon from "@material-ui/icons/HowToVote";
import { userHasPermissions, userHasFunctionRole } from "src/utils/userutils";
import DescriptionIcon from "@material-ui/icons/Description";
import { currentUserIsAuthorized } from "src/utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const RowButtons = (row, customHandlers, ...rest) => {
  // console.log(row.general);

  return (
    <Box display="flex" alignItems="center" flexDirection="column" pr={1}>
      {customHandlers.votePermission &&
      (customHandlers.memberRole || row.general) ? (
        <Button
          color="primary"
          variant="contained"
          size="small"
          aria-label="głosuj"
          component={RouterLink}
          to={`/glosowanie/${row.id}`}
        >
          Głosuj
        </Button>
      ) : (
        <></>
      )}
      {!row.documentNotApplicable && row.documentStructNodeId ? (
        <Tooltip title="Dokumenty">
          <IconButton
            aria-label="dokumenty"
            component={RouterLink}
            to={`/dokumentyglosowanie/${row.documentStructNodeId}/${row.id}`}
          >
            <DescriptionIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
    </Box>
  );
};

const Votings = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
  ...rest
}) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getVotingsByStatus.path, "in_progress", true)
      .then((data) => {
        disableGlobalLoader();
        setRows(addVoteStatisticField(data));
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const votePermission = userHasPermissions(globalData, ["voting"]);

  const memberRole =
    userHasFunctionRole(globalData, "member") ||
    userHasFunctionRole(globalData, "alternate_member");

  const headCells = [
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł głosowania",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "startsAt",
      sortable: true,
      main: false,
      label: "Data rozpoczęcia",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "endsAt",
      sortable: true,
      main: false,
      label: "Data zakończenia",
    },
    {
      id: "votePlaced",
      numeric: false,
      disablePadding: true,
      fieldName: "votePlaced",
      sortable: true,
      main: false,
      label: "Głos oddany",
    },
    {
      id: "statistic",
      numeric: false,
      disablePadding: false,
      fieldName: "statistic",
      isHtml: true,
      sortable: false,
      main: false,
      label: "Statystyka",
      width: "18%",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: {
        votePermission: votePermission,
        memberRole: memberRole,
      },
      component: RowButtons,
    },
  ];

  const noLoginHeadCells = [
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł głosowania",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "startsAt",
      sortable: true,
      main: false,
      label: "Data rozpoczęcia",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "endsAt",
      sortable: true,
      main: false,
      label: "Data zakończenia",
    },
    {
      id: "statistic",
      numeric: false,
      disablePadding: false,
      fieldName: "statistic",
      isHtml: true,
      sortable: false,
      main: false,
      label: "Statystyka",
      width: "18%",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: {
        votePermission: votePermission,
        memberRole: memberRole,
      },
      component: RowButtons,
    },
  ];

  const mobHeadCells = [
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: {
        votePermission: votePermission,
        memberRole: memberRole,
      },
      component: RowButtons,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł głosowania",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "startsAt",
      sortable: true,
      main: false,
      label: "Data rozpoczęcia",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: true,
      fieldName: "endsAt",
      sortable: true,
      main: false,
      label: "Data zakończenia",
    },
    {
      id: "statistic",
      numeric: false,
      disablePadding: false,
      fieldName: "statistic",
      isHtml: true,
      sortable: false,
      main: false,
      label: "Statystyka",
      width: "18%",
    },
  ];

  const onSelectedRowIdsChanged = (viewSelectedRowIds) => {
    setSelectedRowIds(viewSelectedRowIds);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
  };

  return (
    <Page className={classes.root} title="Głosowania w trakcie">
      <Container maxWidth={false}>
        {/* <Toolbar dialogHandler={handleClickOpen} /> */}
        <KmFilteredTable
          markable={false}
          headCells={currentUserIsAuthorized(globalData) ? headCells : noLoginHeadCells}
          mobHeadCells={mobHeadCells}
          rows={rows}
          defaultRowsPerPage={25}
          onSelectedRowIdsChange={onSelectedRowIdsChanged}
          title={"Głosowania w trakcie"}
          highlightField="noVoted"
        />

        <Dialog
          fullScreen={fullScreen}
          open={dialogOpen}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Usuwanie głosowań"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Czy na na pewno chcesz usunąć zaznaczone elementy?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose} color="primary">
              Nie
            </Button>
            <Button onClick={handleDelete} color="primary" autoFocus>
              Tak
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Votings);
